import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { ReferralWiringInformationStore } from '../stores/referralWiringInformationStore';
import { observer } from 'mobx-react';
import { Grid, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Button } from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      marginTop: '20px',
    },
    button: {
      width: '160px',
      marginBottom: '50px',
    },
    margins: {
      marginTop: '20px',
    },
  };
});

export type ReferralWiringInformationSignatureSignedProps = {
  store: ReferralWiringInformationStore;
};
export const ReferralWiringInformationSignatureSigned = observer(
  (props: ReferralWiringInformationSignatureSignedProps) => {
    const classes = useStyles();
    const { store } = props;
    const { userStore } = useStore();

    return (
      <Grid container className={classes.container}>
        <Grid item>
          <CheckCircleIcon style={{ fontSize: '100px', color: 'green' }} />
          <Typography variant="h2">
            Process Completed!
            <br />
          </Typography>
        </Grid>
        <Grid item className={classes.margins}>
          <Typography>
            The referral wiring information process has been completed.
          </Typography>
          <Typography>Your information was successfully received.</Typography>
        </Grid>
        {store.isSigned && (
          <>
          <Grid item>
            <Button
              testId={'download'}
              variant={'outlined'}
              color={'primary'}
              onClick={() =>
                store.downloadSignedWiringInformation(
                  userStore.userInformation.userId
                )
              }
              style={{
                marginTop: 16
              }}
            >
              Download Wiring Information Summary
            </Button>
          </Grid>
          <Grid item>
          <Button
            testId={'edit'}
            variant={'outlined'}
            color={'primary'}
            onClick={() =>
              store.edit = true
            }
            style={{
              marginTop: 16,
              marginBottom: 8
            }}
          >
            Edit
          </Button>
          </Grid>
          </>
        )}
      </Grid>
    );
  }
);
